import { Fragment } from "react";
import { Route, Routes } from "react-router-dom";

import HomePage from "../../pages/HomePage";
import PageNotFound from "../../pages/PageNotFound";
import Product from "../Product/Product";
import DashboardPublic from "./../Home/DashboardPublic";
import Login from "./../Home/Login";

const RoutingUnAuthorized = () => {
  return (
    <Fragment>
      <Routes>
        <Route path="*" element={<Login />} />
        <Route exact path="/" element={<Login />} />
        <Route exact path="/Login" element={<Login />} />
        <Route exact path="/Dashboard" element={<DashboardPublic />} />
      </Routes>
    </Fragment>
  );
};

export default RoutingUnAuthorized;
